import styled from 'styled-components';

import { sideNav, sideNavItem } from '../../styles/mixins';

const Container = styled.nav`
  ${sideNav}
`;

const MenuItem = styled.li`
  ${sideNavItem}
`;

export { Container, MenuItem };
